import styled from 'styled-components';
import colors from '@designSystem/colors';
import Input from '@designSystem/input/input';

interface PropsI {
  modalName?: string;
}

export const Container = styled.section<PropsI>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${colors.white};

  width: ${(props) => (props.modalName === 'order' ? '480px' : '640px')};
  padding-bottom: 40px;

  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
    0px 12px 48px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 560px;

  margin: 40px 40px 0px 40px;

  & h2 {
    margin: 0px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px;

  > div {
    margin: 0;
    margin-top: 40px;
  }
`;

export const ActionRow = styled(Row)`
  width: calc(100% - 80px);
  justify-content: flex-end;

  > button {
    margin-left: 16px;
  }
`;

export type StyledInputI = {
  widthOverride?: string;
};

export const StyledInput = styled(Input)`
  margin-left: 24px;

  width: ${(props: StyledInputI) =>
    props.widthOverride ? props.widthOverride : '100%'};
`;

export const StyledDropDownWrapper = styled.div`
  margin-left: 24px;
`;

export const StyledMobileDropDownWrapper = styled.div`
  margin: 24px 0px 0px 0px;
  width: 100%;
`;

export const HeaderRow = styled(Row)`
  width: calc(100% - 80px);
  justify-content: space-between;
`;

export const MobileContainer = styled(Container)`
  width: 100vw;

  border-radius: 10px 10px 0px 0px;
  box-shadow: none;
`;

type MobileRowI = {
  isActive?: boolean;
};

export const MobileInputRow = styled(Row)`
  flex-direction: column;
  width: calc(100% - 80px);
  display: ${(props: MobileRowI) => (props.isActive ? 'flex' : 'none')};

  margin: 0px 40px 0px 40px;
`;

export const MobileInput = styled(StyledInput)`
  margin: 24px 0px 0px 0px;
`;

export const ModalContainer = styled(Container)`
  width: 100%;
`;

export const ModalRow = styled(Row)`
  width: calc(100% - 80px);
`;
export const ModalButtonsRow = styled(ModalRow)`
  justify-content: flex-end;

  button:first-child {
    margin-right: 10px;
  }
`;
